import { SidebarMenu } from 'components/molecules'

export default function Sidebar() {
  return <SidebarMenu />
}
